import type { TicketStatus } from '../types'
import { type PillTone, SupportPill } from './SupportPill'

// Only a ticket waiting on the user gets the amber tint; the other two states
// need nothing from them, so they read as plain facts.
const STATUS_BADGES: Record<TicketStatus, { label: string; tone: PillTone }> = {
  open: { label: 'Open', tone: 'neutral' },
  awaiting_user: { label: 'Needs your reply', tone: 'amber' },
  resolved: { label: 'Resolved', tone: 'neutral' },
}

export const TicketStatusBadge = ({ status }: { status: TicketStatus }) => {
  const badge = STATUS_BADGES[status]
  return <SupportPill tone={badge.tone}>{badge.label}</SupportPill>
}
